module.exports = __webpack_public_path__ + "img/xtnl-003.1c8921d9.png";